import React,{useState} from "react";
import { Field } from "formik";


export const LabLab =({formik,labData,language}) =>{
    const [labResData,setLabResData] =useState(labData.length !== 0 && labData[0].lab_lab !== null ? labData[0].lab_lab : [])

    // const LabData = ([
    //     {
    //         id: 1,
    //         lab:"GIA"
    //     },
    //     {
    //         id: 2,
    //         lab:"IGI"
    //     },
    //     {
    //         id: 3,
    //         lab:"HRD"
    //     },
    //     {
    //         id: 4,
    //         lab:"OTHER"
    //     }
    // ]);

    const newLabData =labResData.length!==0 ? labResData.split(',').map((value,index) => {
        return {
            id: index,
            lab:value,
        }
    }):null

    return (
        <>
            <div className="row m-0 mt-7">
                <div className="col-12 font-size-lg font-weight-bold mb-3">{language.CCMODE_THEME1_LIST_LAB}</div>
                <div className="col-12" >
                    {newLabData ? newLabData.map((item) => (
                        <label key={item.id} className="search_btn_check">
                            <Field type="checkbox" name="Lab" id={`${item.lab}_lab`} value={item.lab}/>
                            <div className="wLabBox selectBox">
                                <span>{item.lab}</span>
                            </div>
                        </label>
                    )):null}
                </div>
            </div>
        </>
    );
}